<template>
  <div style=" padding: 10px 10px 0 10px;" :class="fullPath=='/index/provid'?'index':''">
    <el-row>
      <el-col :span="24">
        <chosePay :fullPath='fullPath'></chosePay>
      </el-col>
    </el-row>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <span>支付未完成，确定离开本页面吗？(未完成订单可以到我的订单中查询或继续支付)</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleToLeave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import chosePay from '../components/chosePay';

export default {
  name: 'index',
  components: {
    chosePay,
  },
  data () {
    return {
      menuList: [],
      dialogVisible: false,
      leave: false,
      fullPath: ''
    }
  },
  methods: {
    backto () {
      this.$router.push(this.fullPath)
    },
    handleOrderBack () {
      this.$store.commit('orderStepBack')
    },
    handleToLeave () {
      this.leave = true
    },
  },
  mounted () {
  },
  beforeRouteEnter (to, from, next) {
    // 当守卫执行前，组件实例还没被创建  不能！获取组件实例 `this`
    next(vm => {  //vm为vue的实例,相当于this  通过 `vm` 访问组件实例
      console.log(from.path, 'ccccc')
      if (from.path == '/index/provid') {

      }
      // /smsindex/smspackage
      // /index/provid
      // vm.isPath = from.name

      vm.fullPath = from.path;
      // 通过 `vm` 访问组件实例,将值传入newPath
      //beforeRouteEnter守卫在导航确认前被调用，因此守卫不能访问 this
      //在template里已经可以用this.newPath来获取到from所带的name值
      vm.newPath = from.name
    });
  },
  beforeRouteLeave (to, from, next) {
    if (this.$store.state.isPayDone == false) {
      if (window.confirm('您的订单尚未支付，请到"企业中心-我的订单"完成支付')) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
}
</script>

<style lang="less" scoped>
.index {
  padding: 10px 10px 0 10px;
}
</style>
